// facilitySlice.ts
import { createSlice } from "@reduxjs/toolkit";

const facilitySlice = createSlice({
    name: "facilityType",
    initialState: {
        facility_type: null,
    },
    reducers: {
        setFacilityTypeDetails(state, action) {
            state.facility_type = action.payload;
        },
    },
});

export const { setFacilityTypeDetails } = facilitySlice.actions;
export default facilitySlice.reducer;
